// extracted by extract-css-chunks-webpack-plugin
module.exports = {"close":"close-VkYz2r8X","num":"num-1SbYe_Uz","current":"current-3qlbeC-h","total":"total-2FOlyv-H"};